import React from "react";
import { Instagram, MessageCircle, Mail, BadgeCheck } from "lucide-react";

const company = [
  { label: "About Us",   href: "#about" },
  { label: "Contact Us", href: "#contact" },
];

const policies = [
  { label: "Privacy Policy",     href: "#" },
  { label: "Terms & Conditions", href: "#" },
  { label: "Shipping Policy",    href: "#" },
  { label: "Refund Policy",      href: "#" },
];

export default function Footer() {
  return (
    <footer className="border-t border-white/5 bg-black px-5 py-12">
      <div className="mx-auto max-w-6xl">
        <div className="flex flex-col items-start gap-10 sm:flex-row sm:items-start sm:justify-between">
          <div className="max-w-sm">
            <div className="font-display text-3xl text-white">
              BAJRANG <span className="text-fire">VEDA</span>
            </div>
            <p className="mt-2 text-sm text-neutral-500">
              100% Ayurvedic formula that supports healthy weight gain, appetite,
              digestion, stamina and strength.
            </p>
            <div className="mt-4 inline-flex items-center gap-2 rounded-full border border-[#FFC107]/30 bg-[#FFC107]/10 px-3 py-1 text-[11px] uppercase tracking-widest text-[#FFC107]">
              <BadgeCheck size={12} /> AYUSH-licensed manufacture
            </div>
          </div>

          <div id="contact" className="grid grid-cols-2 gap-8 text-sm sm:grid-cols-3">
            <div>
              <div className="mb-2 text-[11px] uppercase tracking-widest text-neutral-500">Company</div>
              <ul className="space-y-1.5 text-neutral-300">
                {company.map((c) => (
                  <li key={c.label}>
                    <a href={c.href} className="hover:text-[#FF7A00]">{c.label}</a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <div className="mb-2 text-[11px] uppercase tracking-widest text-neutral-500">Policies</div>
              <ul className="space-y-1.5 text-neutral-300">
                {policies.map((p) => (
                  <li key={p.label}>
                    <a href={p.href} className="hover:text-[#FF7A00]">{p.label}</a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <div className="mb-2 text-[11px] uppercase tracking-widest text-neutral-500">Reach Us</div>
              <ul className="space-y-1.5 text-neutral-300">
                <li className="flex items-center gap-2">
                  <MessageCircle size={14} className="text-[#FF7A00]" />
                  <a href="https://wa.me/918817725280" target="_blank" rel="noopener noreferrer" className="hover:text-[#FF7A00]">
                    +91-88177-25280
                  </a>
                </li>
                <li className="flex items-center gap-2">
                  <Mail size={14} className="text-[#FF7A00]" />
                  <a href="mailto:care@bajrangveda.in" className="hover:text-[#FF7A00]">care@bajrangveda.in</a>
                </li>
                <li className="flex items-center gap-2">
                  <Instagram size={14} className="text-[#FF7A00]" />
                  <a href="#" className="hover:text-[#FF7A00]">@bajrangveda</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-10 border-t border-white/5 pt-6 text-center text-xs text-neutral-600">
          © {new Date().getFullYear()} Bajrang Veda. Made in India.
        </div>
      </div>
    </footer>
  );
}
